import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useCallback, useEffect, useState } from 'react';
import { Button } from '@ludolio/shared-ui';
import { FullPageMessage, FullPageSpinner } from '@/components/FullPageMessage';
import { LabsUnavailable } from '@/components/LabsUnavailable';
import { RequireAuth } from '@/components/RequireAuth';
import { getErrorMessage, getErrorStatus, labsApi } from '@/lib/api';

export const Route = createFileRoute('/')({
  component: () => (
    <RequireAuth>
      <HomeRedirect />
    </RequireAuth>
  ),
});

function HomeRedirect() {
  const [state, setState] = useState<{ slug: string } | 'unavailable' | 'loading' | { error: string }>('loading');

  const load = useCallback(() => {
    setState('loading');
    labsApi
      .context()
      .then((context) => setState({ slug: context.organization.slug }))
      .catch((error) => {
        if (getErrorStatus(error) === 404) setState('unavailable');
        else setState({ error: getErrorMessage(error) });
      });
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (state === 'loading') return <FullPageSpinner />;
  if (state === 'unavailable') return <LabsUnavailable />;
  if ('error' in state) {
    return (
      <FullPageMessage title={state.error}>
        <Button type="button" onClick={load}>Try again</Button>
      </FullPageMessage>
    );
  }
  return <Navigate to="/$orgSlug/projects" params={{ orgSlug: state.slug }} replace />;
}
